module.exports = __webpack_public_path__ + "static/media/machix__avatar.0eec24f8.jpg";